import React, { useEffect } from "react";
import cancelIcon from "../../../assets/cancel.svg";
import styles from "./internalModal.module.scss";

const InternalModal = ({
  children,
  open,
  onClose,
  title,
}: {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  title: string;
}) => {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className={styles.modalContainer}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          <button
            type="button"
            className={styles.secondaryButton}
            onClick={onClose}
          >
            {cancelIcon ? (
              <img
                className={styles.cancelIcon}
                src={cancelIcon}
                alt=""
                aria-hidden="true"
              />
            ) : (
              "x"
            )}
          </button>
        </div>
        <div className={styles.body}>{children}</div>
        <div className={styles.footer}></div>
      </div>
    </div>
  );
};

export default InternalModal;
